import { render, staticRenderFns } from "./FriendLinkForm.vue?vue&type=template&id=0ad3eab0&scoped=true&"
import script from "./FriendLinkForm.vue?vue&type=script&lang=js&"
export * from "./FriendLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad3eab0",
  null
  
)

export default component.exports